import { render } from "./FullPVTReport.vue?vue&type=template&id=5bf5949b"
import script from "./FullPVTReport.vue?vue&type=script&lang=js"
export * from "./FullPVTReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__